import React from 'react';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import RepeatIcon from '@material-ui/icons/Repeat';
import Paper from '@material-ui/core/Paper';
import {connect} from 'react-redux'
import {getAuditTrails} from '../store/actions/auditTrailActions'
import Typography from '@material-ui/core/Typography';
import formatDate from '../Classes/FormatDate';

  class AuditTrail extends React.Component {

    constructor(props) {
        super(props);
        this.state={
          POSAPId:this.props.location.state.POSAPId,
          array: [{value:1 , action1:"document submitted" , action2:"document requested", action3:"document rejected",action4:"delivery schedule uploaded",action5:"delivery schedule approved"},]
         } 
        } 

    componentDidMount(){  
      this.props.getAuditTrails()
    }  

    render()
    {
            console.log(this.props.auditpouser.auditPouser.recordset, "@@@@@")
            return (
              <div className="conatiner ">

              <div className="col-md-4 " style={{marginTop:"3rem"}}>
              <b>PO:</b> {this.state.POSAPId}
               </div>

               {this.props.auditpouser.auditPouser && this.props.auditpouser.auditPouser.recordset && this.props.auditpouser.auditPouser.recordset.length > 0 && this.props.auditpouser.auditPouser.recordset.map((element, Index) =>
              <Timeline align="alternate" className="timeline">
                <TimelineItem>
                  <TimelineOppositeContent>
                    <Typography variant="body2" color="textSecondary">
                      {formatDate(element.CreatedOn)}
                    </Typography>
                  </TimelineOppositeContent>
                  <TimelineSeparator className="timeline-separator"  >
                    <TimelineDot color="green">
                      
                    </TimelineDot>
                    <TimelineConnector  />
                  </TimelineSeparator>
                  
                  <TimelineContent >
                    <Paper elevation={3}   style={{ padding: 8,
                                                   backgroundColor: "#E4E6EB",
                                                    border: "1px solid black"
                                                    }} >
                      <Typography variant="h6" component="h1">
                     Role: {element.RoleName}
                      </Typography>
                      <Typography>Action: {element.ActionName}</Typography>
                    </Paper>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineOppositeContent>
                    <Typography variant="body2" color="textSecondary">
                      {/* 10:00 am */}
                    </Typography>
                  </TimelineOppositeContent>
                  <TimelineSeparator className="timeline-separator" >
                    <TimelineDot color="#2E3135">
                      
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent>
                    <Paper elevation={3}  style={{ padding: 8, border: "0.5px solid grey"}}>
                      <Typography variant="h6" component="h1">
                      Role:
                      </Typography>
                      <Typography>Action:</Typography>
                    </Paper>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator className="timeline-separator" >
                    <TimelineDot color="#2E3135" variant="outlined">
                     
                    </TimelineDot>
                    <TimelineConnector  />
                  </TimelineSeparator>
                  <TimelineContent>
                    <Paper elevation={3}  style={{ padding: 8, border: "0.5px solid grey"}}>
                      <Typography variant="h6" component="h1">
                      Role:
                      </Typography>
                      <Typography>Action:</Typography>
                    </Paper>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineOppositeContent>
                    <Typography variant="body2" color="textSecondary">
                      {/* 9:30 am */}
                    </Typography>
                  </TimelineOppositeContent>
                  <TimelineSeparator className="timeline-separator" >
                    <TimelineDot color="#2E3135" >
                     
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent>
                    <Paper elevation={3}  style={{ padding: 8, border: "0.5px solid grey"}}>
                      <Typography variant="h6" component="h1">
                      Role:
                      </Typography>
                      <Typography>Action:</Typography>
                    </Paper>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineOppositeContent>
                    <Typography variant="body2" color="textSecondary">
                      {/* 9:30 am */}
                    </Typography>
                  </TimelineOppositeContent>
                  <TimelineSeparator className="timeline-separator" >
                    <TimelineDot color="#2E3135" >
                     
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent>
                    <Paper elevation={3}  style={{ padding: 8, border: "0.5px solid grey"}}>
                      <Typography variant="h6" component="h1">
                      Role:
                      </Typography>
                      <Typography>Action:</Typography>
                    </Paper>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator className="timeline-separator" >
                    <TimelineDot color="#2E3135">
                      
                    </TimelineDot>
                  </TimelineSeparator>
                  <TimelineContent>
                    <Paper elevation={3}  style={{ padding: 8, border: "0.5px solid grey"}}>
                      <Typography variant="h6" component="h1">
                      Role:
                      </Typography>
                      <Typography>Action:</Typography>
                    </Paper>
                  </TimelineContent>
                </TimelineItem>
                
              </Timeline>
)}
              </div>
            
            );
        
    }
}
const mapStateToProps  = (state) => ({auditpouser:state.auditTrailReducer})
export default connect(mapStateToProps, {getAuditTrails}) (AuditTrail);
